import axios from '@/libs/api.request'

export const getVersionList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/appversion'
  })
}

export const addVersion = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/appversion'
  })
}

export const editVersion = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/appversion'
  })
}

export const delVersion = (id) => {
  return axios.request({
    method: 'delete',
    url: '/appversion/' + id
  })
}

export const getVersionInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/appversion/' + id
  })
}
